import ProficiencyGroupsBox from './ProficiencyGroupsBox';

export default ProficiencyGroupsBox;
export { ProficiencyGroupsBox };
